import type { Messages } from '@lingui/core';
import { messages as enGB } from '../locales/en-GB/messages';
import { messages as enUS } from '../locales/en-US/messages';
import { messages as enXA } from '../locales/en-XA/messages';
import { messages as es } from '../locales/es/messages';
import { messages as ja } from '../locales/ja/messages';
import { messages as ko } from '../locales/ko/messages';
import { messages as ptBR } from '../locales/pt-BR/messages';
import { messages as zhHans } from '../locales/zh-Hans/messages';
import { messages as zhHant } from '../locales/zh-Hant/messages';
import type { AppLocale } from './locales';

/**
 * Compiled by `lingui compile` from locales/<locale>/messages.po — generated, never edited.
 * A few KB each, so every pack is bundled and nothing is lazy-loaded: no screen can render
 * before its strings exist, on any platform.
 */
export const catalogs: Readonly<Record<AppLocale, Messages>> = {
  'en-US': enUS as Messages,
  'en-GB': enGB as Messages,
  es: es as Messages,
  'pt-BR': ptBR as Messages,
  'zh-Hans': zhHans as Messages,
  'zh-Hant': zhHant as Messages,
  ja: ja as Messages,
  ko: ko as Messages,
  'en-XA': enXA as Messages,
};
